import type { DB, ObjectID } from '@/types/common';

export enum JobExperience {
	NONE = 'NONE',
	DEBUTANT = 'DEBUTANT',
	ADVANCED = 'ADVANCED',
	EXPERT = 'EXPERT',
}

export enum JobService {
	talentplug = 'talentplug',
	interactionweb = 'interactionweb',
	merciii = 'merciii',
	vigijobs = 'vigijobs',
	indeed = 'indeed',
	meteojob = 'meteojob',
}

export enum JobServiceStatus {
	unpublished = 'unpublished',
	draft = 'draft',
	published = 'published',
	deleted = 'deleted',
	archived = 'archived',
}

export interface IBusinessSector {
	name: string;
	nameSlug?: string;
	pictogram?: string;
}

export interface IBusinessSectorDB extends IBusinessSector, DB {}

export interface IJob {
	name: string;
	code?: string;
	PCS?: string;
	slugs: string[];
	verified: boolean;
	businessSectors: Array<ObjectID>;
	notSelectable?: boolean;
}

export interface IJobDB extends IJob, DB {}

export interface IDegreeLevel {
	slug: string;
	name: string;
	rank: number;
}

export interface IDegreeLevelDB extends IDegreeLevel, DB {}

export interface IJobContract {
	id: string;
	talentplugId: number;
	name: string;
}

export interface IJobStored {
	label: string;
	value: string;
	slug: string;
}

export type JobOption = IJobStored;

export interface DegreeLevelOption {
	name: string;
	value: string;
	slug: string;
}

export interface IWorkerJob {
	jobId: ObjectID;
	job?: IJobDB;
	experience: JobExperience | null;
	degreeLevel?: string;
}

export interface IInterimJob {
	jobId: ObjectID;
	degreeLevel?: string;
	experience: JobExperience | null;
}
